<template>
  <el-dialog :visible.sync="visible" title="订单核验" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px">
      <!-- 订单详情(只读) -->
      <el-form-item label="订单号">
        <el-input v-model="orderInfo.orderCode" disabled></el-input>
      </el-form-item>
      <el-form-item label="用户ID">
        <el-input v-model="orderInfo.userId" disabled></el-input>
      </el-form-item>
      <el-form-item label="充值金额">
        <el-input v-model="orderInfo.amount" disabled></el-input>
      </el-form-item>
      <el-form-item label="区块链">
        <el-input v-model="orderInfo.chainName" disabled></el-input>
      </el-form-item>
      <el-form-item label="代币">
        <el-input v-model="orderInfo.tokenSymbol" disabled></el-input>
      </el-form-item>
      <el-form-item label="钱包地址">
        <el-input v-model="orderInfo.walletAddress" disabled></el-input>
      </el-form-item>
      <!-- 核验表单 -->
      <el-form-item label="核验状态" prop="verificationStatus">
        <el-select v-model="dataForm.verificationStatus" placeholder="请选择核验状态">
          <el-option label="已到账" :value="1"></el-option>
          <el-option label="金额不符" :value="2"></el-option>
          <el-option label="未到账" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="交易哈希">
        <el-input v-model="dataForm.cryptoTxId" placeholder="请输入区块链交易哈希(可选)"></el-input>
      </el-form-item>
      <el-form-item label="核验人">
        <el-input v-model="dataForm.verifiedBy" disabled></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="dataForm.remark" type="textarea" placeholder="核验未通过时必须填写备注"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">确认</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    // 备注验证规则
    const validateRemark = (rule, value, callback) => {
      if ((this.dataForm.verificationStatus === 2 || this.dataForm.verificationStatus === 3) && !value) {
        callback(new Error('核验未通过时必须填写备注'))
      } else {
        callback()
      }
    }
    return {
      visible: false,
      dataForm: {
        id: '',
        orderCode: '',
        verificationStatus: '',
        cryptoTxId: '',
        verifiedBy: '',
        remark: ''
      },
      orderInfo: {},
      dataRule: {
        verificationStatus: [
          { required: true, message: '核验状态不能为空', trigger: 'blur' }
        ],
        remark: [
          { validator: validateRemark, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        // 获取订单详情
        this.$http.get(`/crypto/order/${this.dataForm.id}`).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.orderInfo = res.data
          this.dataForm.orderCode = res.data.orderCode
          // 自动填充当前登录用户
          this.dataForm.verifiedBy = this.$store.state.user.name
        }).catch(() => {})
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http.post('/crypto/order/verify', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
